import { useEffect, useState } from "react";

import styled from "styled-components";

import { Panda, getPandasForAddress } from "../../utils/getSnapshot";

import * as anchor from "@project-serum/anchor";

import { useAnchorWallet } from "@solana/wallet-adapter-react";
import { WalletDialogButton } from "@solana/wallet-adapter-material-ui";

import { Header, ButtonIcon } from '../../components'

import {
  shortenAddress,
} from "../../utils/candyMachine";
import { sleep } from "../../utils";
import { craneDodge } from "../../utils/craneDodge";
import { PowerSettingsNew } from "@material-ui/icons";

const ConnectButton = styled(WalletDialogButton)``;

interface CraneDodgeProps {
  connection: anchor.web3.Connection;
  txTimeout: number;
}

function powerupDescriptionByAttributes(attributes: {trait_type: string, value: string}[]): string[] {
    let powerups: string[] = [];
    attributes.map(attribute => {
        if (attribute.value.includes("Fedora")) {
            powerups.push("FEDORA - Freezes time for a random interval - cause fedora's are COOL.");
        }

        if (attribute.value.includes("Only")) {
            powerups.push("UP ONLY VR - Sends the cranes where they belong. Up.")
        }

        if (attribute.value.includes("Oakley")) {
            powerups.push("OAKLEYS - Sends an email to Spike complaining about this asset");
        }

        if (attribute.value.includes("Shitcoin")) {
            powerups.push("SHITCOIN EYES - Transforms on-screen cranes into little pieces of shit that move slower")
        }

        if (attribute.value.includes("Fast Food")) {
            powerups.push("FAST FOOD - Speed up your character. Probably too much.")
        }

        if (attribute.value.includes("NGMI")) {
            powerups.push("NGMI - Instantly lose, but add 30 to your score. Use this when about to die.")
        }

        if (attribute.value.includes("Pain")) {
            powerups.push("MAX PAIN - No powerup, but you can endure a SECOND HIT. My god.")
        }
    })

    if(powerups.length === 0) {
        powerups.push("GENERIC - No asset-derive powerups. n00b lmao");
    }

    return powerups;
}
function powerupByAttributes(attributes: {trait_type: string, value: string}[]): string {
    const powerups: string[] = [];
    attributes.map(attribute => {
        if (attribute.value.includes("Fedora")) {
            powerups.push("freeze");
        }
        if (attribute.value.includes("VR")) {
            powerups.push("up_only");
        }

        if (attribute.value.includes("Oakley")) {
            powerups.push("oakleys");
        }
        if (attribute.value.includes("Shitcoin")) {
            powerups.push("shitcoin");
        }

        if (attribute.value.includes("Fast Food")) {
            powerups.push("fast_food")
        }

        if (attribute.value.includes("NGMI")) {
            powerups.push("ngmi")
        }

        if (attribute.value.includes("Pain")) {
            powerups.push("max_pain")
        }
    })

    if(powerups.length === 0) {
        powerups.push("generic");
    }
    return powerups[Math.floor(Math.random()*powerups.length)];
}
const CraneDodge = (props:CraneDodgeProps) => {
  const [pandas, setPandas] = useState<Panda[]>();
  const [chosenPanda, setChosenPanda] = useState<Panda>();
  const [gameStarted, setGameStarted] = useState<boolean>(false);

  const wallet = useAnchorWallet();

  const start = function(panda: Panda) {
    setChosenPanda(panda);
    setGameStarted(true);
    sleep(5000);
    craneDodge(panda.image, wallet?.publicKey, powerupByAttributes(panda.attributes))
  }
  
  useEffect(() => {
    (async () => {
  })();
}, [wallet, props.connection, chosenPanda]);

  useEffect(() => {
    (async () => {
      if (wallet) {
        const pandas = await getPandasForAddress(props.connection, wallet.publicKey);
        setPandas(pandas);
      }
    })();
  }, [wallet, props.connection]);

  return (
    <div className="page-arcade">
      <Header>
        {!wallet ? (
          <ConnectButton>
            <>
              <ButtonIcon color="white" />
              Connect Wallet
            </>
          </ConnectButton>
        ) : (
          <div className="button dark">
            <ButtonIcon color="white" />
            {shortenAddress(wallet.publicKey?.toBase58() || "")}
          </div>
        )}
      </Header>
      <div className="hero section centered">
        <div className="container">
          <h1 className="hero-heading">NGMI Battle Cranes</h1>
          <div id="phaser-target"></div>
          {!wallet ? (
            <>
              <p>Please connect to play.</p>
              <ConnectButton>
                <>
                  <ButtonIcon color="black" />
                  Connect Wallet
                </>
              </ConnectButton>
            </>
          ) : (
            <>
              {pandas && pandas.length > 0 ? (
                <>
                  {chosenPanda ? (
                    <>
                      <div 
                        className="marketplace-item panda"
                      >
                        {!gameStarted ? (
                          <>
                            <p>Chosen Panda:</p>
                            <img src={chosenPanda.image} className="marketplace-item-image" />
                            <p>{chosenPanda.name}</p>
                          </>
                        ): (
                          <>
                          </>
                        )}
                      </div>
                    
                    </>
                  ): (
                    <>
                      <p>Choose which panda you want to play with:</p>
                      <div className="marketplace-items panda-chooser">
                        {pandas.map((panda, i) => {
                          return (
                            <div 
                              className="marketplace-item panda"
                              onClick={() => start(panda)}
                              key={i}
                            >
                              <img src={panda.image} className="marketplace-item-image panda-chooser-image" />
                              <p>{panda.name}</p>
                              {powerupDescriptionByAttributes(panda.attributes).map(v => (
                               <p>{v}</p>   
                              ))}
                              
                            </div>
                          )
                        })}
                      </div>
                    </>
                  )}
                  
                </>
              ) : (
                <p className="">
                  You must own at least one panda to play!
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default CraneDodge;